export default __webpack_public_path__ + "static/media/cctv.c253d9c5.png";